/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Most_Popular_BadgeInputs */



/**
* | output |
* | --- |
* | "Most Popular" |
*
* @param {Signup_Most_Popular_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_most_popular_badge = /** @type {((inputs?: Signup_Most_Popular_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Most_Popular_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le Plus Populaire")
	if (locale === "de") return /** @type {LocalizedString} */ ("Am beliebtesten")
	if (locale === "it") return /** @type {LocalizedString} */ ("I più popolari")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Самые популярные")
	if (locale === "es") return /** @type {LocalizedString} */ ("Más populares")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最受欢迎")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最も人気のある")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सबसे लोकप्रिय")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mais populares")
	return /** @type {LocalizedString} */ ("Most Popular")
});